import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { Box } from '@coursera/coursera-ui';

import { Button, LargeText, Spacer } from 'bundles/enterprise-ui/components';

import _t from 'i18n!nls/enterprise-admin-skills';

export const AboutSkillSetTypes = ({ onClose }: { onClose: () => void }) => {
  return (
    <div>
      <h2>{_t('About our SkillSet Types')}</h2>
      <Spacer size={24} />
      <Typography2 component="p">
        {_t('Our simple SkillSet classifications, can help you select SkillSets to suit all your learner types.')}
      </Typography2>
      <Spacer size={24} />
      <LargeText>{_t('Literacy')}</LargeText>
      <Spacer size={12} />
      <Typography2 component="p">
        {_t(
          'These are SkillSets created to provide everyone within your organization with foundational skills in a key domain. For example our data science literacy SkillSets equip employees to understand AI applications, make data-driven decisions, and empower them to work better with data teams. '
        )}
      </Typography2>
      <Spacer size={24} />
      <LargeText>{_t('Reskill')}</LargeText>
      <Spacer size={12} />
      <Typography2 component="p">
        {_t(
          'SkillSets designed to reskill talent for in-demand jobs, from aspiring data scientists to cyber security engineers — using world-class content and credentials delivered in a skills-first learning experience. '
        )}
      </Typography2>
      <Spacer size={24} />
      <LargeText>{_t('Upskill')}</LargeText>
      <Spacer size={12} />
      <Typography2 component="p">
        {_t(
          'Deepskill your subject matter experts with SkillSets that build toward true skill mastery, focusing on key skills from TensorFlow and deep learning to GCP Cloud and Biostatistics.'
        )}
      </Typography2>
      <Spacer size={24} />
      <Box justifyContent="center">
        <Button variant="primary" onClick={onClose}>
          {_t('Close')}
        </Button>
      </Box>
    </div>
  );
};
